import styles from './AppBar.module.css';

interface AppBarProps {
  vehicle: string;
}

export function AppBar({ vehicle }: AppBarProps) {
  return (
    <header className={styles.appBar}>
      <div className={styles.appBarContent}>
        <div className={styles.vehicleBlock}>
          <span className={styles.label}>Vehicle</span>
          <span className={styles.vehicle}>{vehicle}</span>
        </div>
        <button className={styles.changeBtn} type="button">
          Change
        </button>
      </div>
    </header>
  );
}
